<template>
  <div>
    <BaseModal :config="docModalConfig" @ResetFields="resetFields">
      <BaseDocumentMgrandDropoff
        ref="informationTrackingDocumentMgr"
        :mgrGridQuery="filterCondition"
        :transactionRecord="transactionRecord"
      ></BaseDocumentMgrandDropoff>
    </BaseModal>
  </div>
</template>

<script>
import BaseDocumentMgrandDropoff from "@/components/base/BaseDocumentMgrandDropoff.vue";
import BaseModal from "@/components/base/BaseModal.vue";
import BaseDocument from "@/models/BaseModelDocument.js";
import BaseModelInformationTracking from "@/models/BaseModelInformationTracking.js";
import {updateDocTypeReceivedConfig} from'@/components/forms/InfoTrackerDocumentDropoffForm.js';
import { mapGetters, mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
  name: "InfoTrackerDocumentDropoffForm",
  props: {
    docModalConfig: {},
    filterCondition: {},
    transactionRecord: {}
  },
  components: {
    BaseModal,
    BaseDocumentMgrandDropoff
  },
  computed: {
    ...mapGetters("getModule", ["withFilter"]),
    ...mapState("postModule", ["response"])
  },
  data: function() {
    return {
      businessEvent: "Information Tracking",
      BaseDocument: BaseDocument,
      BaseModelInformationTracking: BaseModelInformationTracking,
      infoTrackerUpdateData : [],
      updateDocTypeReceivedConfig:updateDocTypeReceivedConfig
    };
  },
  methods: {
    ...mapActions("postModule", ["CreateItems", "UpdateItems"]),
    resetFields: function() {
      //let loader = this.$loading.show();
      this._APICrudPopup("APICrudpopup");
      const self = this;
      let DocumentList = self.withFilter(self.BaseDocument.list, {
        filter: `BusinessEvent eq 'Information Tracking'`
       
      });
      if(DocumentList.length>0)
      {
      //Check if Signature page type Doc exists
      let signatureDocument = DocumentList.filter(obj => {
        return (
          obj.DocumentType == "Signature Page" &&
          obj.TransactionID == self.transactionRecord.Id
        );
        //&& obj.InvestmentId == form.InvestmentId && obj.TaxYear == form.TaxYear && obj.TaxQuarter == form.TaxQuarter
      });

      if (signatureDocument.length > 0) {
        self.transactionRecord.SignaturePage = "Received";
      } else {
        self.transactionRecord.SignaturePage = "Not Received";
      }

      //Check if 83b type Doc exists
      let Receive83bDocument = DocumentList.filter(obj => {
        return (
          obj.DocumentType == "83(b)" &&
          obj.TransactionID == self.transactionRecord.Id
        );
        //&& obj.InvestmentId == form.InvestmentId && obj.TaxYear == form.TaxYear && obj.TaxQuarter == form.TaxQuarter
      });

      if (Receive83bDocument.length > 0) {
        self.transactionRecord.Receive83b = "Received";
      } else {
        self.transactionRecord.Receive83b = "Not Received";
      }

      //Copied into local json variable as vuex adds a lot more fields
      self.infoTrackerUpdateData =[];
      let localUpdateData = {};
      localUpdateData.Id = self.transactionRecord.Id;
      localUpdateData.ProgramId = self.transactionRecord.ProgramId;
      localUpdateData.ProgramTitle = self.transactionRecord.ProgramTitle;
      localUpdateData.ProgramAlias = self.transactionRecord.ProgramAlias;
      localUpdateData.PartnerId = self.transactionRecord.PartnerId;
      localUpdateData.PartnerTitle = self.transactionRecord.PartnerTitle;
      localUpdateData.SignaturePage = self.transactionRecord.SignaturePage;
      localUpdateData.Receive83b = self.transactionRecord.Receive83b;
      localUpdateData.Receive83bFiledWithIRS =
        self.transactionRecord.Receive83bFiledWithIRS;
      localUpdateData.AmountOwed = self.transactionRecord.AmountOwed;
      localUpdateData.Payment = self.transactionRecord.Payment;
      localUpdateData.MethodofPayment = self.transactionRecord.MethodofPayment;
      localUpdateData.CheckNumber = self.transactionRecord.CheckNumber;
      localUpdateData.DateDeposited = self.transactionRecord.DateDeposited;
      localUpdateData.DateWired = self.transactionRecord.DateWired;

      self.infoTrackerUpdateData.push(localUpdateData);


       console.log(localUpdateData);
      //Used another config to update only two fields of Information Tracking  
      let updateItem = {
        list: self.updateDocTypeReceivedConfig,
        payload:  self.infoTrackerUpdateData[0]
      };

      this.UpdateItems(updateItem).then(res => {
        self.$emit("SaveComplete");
        self.$swal.close();
        //loader.hide();
        //this._AlertPopup("Data Saved Successfully!", "success");
      }).catch(error=>{
          self._AlertPopup("Some Error Occurred!","info");
      }).finally(()=>{
          //loader.hide();
        })
      }
      else
      {
        //loader.hide();
        self.$swal.close();
      }
    }
  },
  mounted() {}
};
</script>
